import { render, staticRenderFns } from "./ChatAction.vue?vue&type=template&id=781533da&scoped=true&"
import script from "./ChatAction.vue?vue&type=script&lang=js&"
export * from "./ChatAction.vue?vue&type=script&lang=js&"
import style0 from "./ChatAction.vue?vue&type=style&index=0&id=781533da&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781533da",
  null
  
)

export default component.exports